import React from 'react';
import strings from 'utils/strings';
import AlertBox from 'components/CreateNotification/alert';
import updateSubTestResult from 'api/updateSubTestResult';

class EditorTestResultOverview extends React.Component {
	constructor(props) {
		super(props);

		const [{key = null} = {}] = this.props.selectedTestUser || [];
		const selectedObj = this.props.selectedId[0];

		let parsedAnswers = {};
		try {
			parsedAnswers = selectedObj.answers
				? JSON.parse(selectedObj.answers)
				: {};
		} catch {
			parsedAnswers = {};
		}

		this.state = {
			testKey: key,
			selectedIdObject: selectedObj,
			editedJson: JSON.stringify(parsedAnswers, null, 2),
			jsonError: false,

			totalCorrect: selectedObj.totalCorrect || 0,
			zScore: selectedObj.zScore || 0,
			scaledScore: selectedObj.scaledScore || 0,
			tScore: selectedObj.tScore || 0,
			percentile: selectedObj.percentile || 0,
			standardScore: selectedObj.standardScore || 0,

			showAlert: false,
			success: null,
			message: '',
			isConfirmedDisabled: false,
		};
	}

	onJsonChange = (e) => {
		const value = e.target.value;
		try {
			JSON.parse(value);
			this.setState({editedJson: value, jsonError: false});
		} catch {
			this.setState({editedJson: value, jsonError: true});
		}
	};

	onScoreChange = (field, value) => {
		this.setState({[field]: value});
	};

	onConfirm = () => {
		const {
			editedJson,
			jsonError,
			selectedIdObject,
			testKey,
			totalCorrect,
			zScore,
			scaledScore,
			tScore,
			percentile,
			standardScore,
		} = this.state;

		if (jsonError) return;

		let parsedAnswers;
		try {
			parsedAnswers = JSON.parse(editedJson);
		} catch {
			this.setState({
				jsonError: true,
				showAlert: true,
				success: false,
				message: strings.invalidJsonFormat,
			});
			return;
		}

		const payload = {
			subtestId: selectedIdObject.id,
			testKey,
			answers: parsedAnswers,
			totalCorrect: Number(totalCorrect),
			zScore: Number(zScore),
			scaledScore: Number(scaledScore),
			tScore: Number(tScore),
			percentile: Number(percentile),
			standardScore: Number(standardScore),
		};

		this.setState({isConfirmedDisabled: true});
		updateSubTestResult(payload).then((res) => {
			if (!res || res.error) {
				this.setState({
					showAlert: true,
					success: false,
					message: strings.opsSomethingWentWrongCap,
				});
			} else {
				// Refresh parent table
				this.props.getTestsBySearch({testKey});

				this.setState({
					showAlert: true,
					success: true,
					message: strings.subtestResultsUpdatedSuccessfully,
				});
			}

			setTimeout(() => {
				this.setState({showAlert: false});
				this.props.onEditModelConfirm();
			}, 2500);
		});
	};

	onCancel = () => {
		this.props.onEditModelCancel();
		this.setState({
			showAlert: false,
			jsonError: false,
			message: '',
		});
	};

	renderScoreInput(label, field) {
		return (
			<div className="editor-score-row">
				<label className="editor-label">{label}</label>
				<input
					type="number"
					className="editor-input"
					value={this.state[field]}
					onChange={(e) => this.onScoreChange(field, e.target.value)}
				/>
			</div>
		);
	}

	render() {
		const {editedJson, jsonError, showAlert, message, success} = this.state;

		return (
			<div className="editor-wrapper">
				<h3 className="editor-header">{strings.editSubtestResult}</h3>

				{/* SCORES */}
				<div className="editor-card">
					<h4 className="editor-section-title">{strings.scores}</h4>

					<div className="editor-grid">
						{this.renderScoreInput(strings.totalCorrectLabel, 'totalCorrect')}
						{this.renderScoreInput(strings.zScoreLabel, 'zScore')}
						{this.renderScoreInput(strings.scaledScoreLabel, 'scaledScore')}
						{this.renderScoreInput(strings.tScoreLabel, 'tScore')}
						{this.renderScoreInput(strings.percentileLabel, 'percentile')}
						{this.renderScoreInput(
							strings.standardScoreLabel,
							'standardScore'
						)}
					</div>
				</div>

				{/* JSON EDITOR */}
				<div className="editor-card">
					<h4 className="editor-section-title">{strings.answersJson}</h4>

					<textarea
						className={`editor-textarea ${
							jsonError ? 'editor-textarea-error' : ''
						}`}
						value={editedJson}
						onChange={this.onJsonChange}
					/>

					{jsonError && (
						<p className="editor-error-text">{strings.invalidJsonFormat}</p>
					)}
				</div>

				{/* BUTTONS */}
				<div className="editor-btn-row">
					<button
						className="lit-btn bg-primary"
						disabled={jsonError}
						onClick={this.onConfirm}
					>
						{strings.confirm}
					</button>

					<button
						className="lit-btn bg-negative"
						onClick={this.onCancel}
					>
						{strings.cancel}
					</button>
				</div>

				{showAlert && (
					<AlertBox
						type={success ? 'success' : 'error'}
						message={message}
					/>
				)}
			</div>
		);
	}
}

export default EditorTestResultOverview;
